import React from "react";
import { connect } from "react-redux";

import NewHome from "./NewHome";
import OldHome from "./OldHome.";

function HomeApp({ themeReducer: { theme } }) {
  if (theme === "theme3" || !theme) return <NewHome />;
  return <OldHome />;
}

const mapStateToProps = ({ keycloak, theme: themeReducer }) => {
  return {
    kc: keycloak,
    themeReducer,
  };
};
export default connect(mapStateToProps)(HomeApp);
